/* react-router keeps the history index here; 0 means the page was opened directly */
export const canGoBack = () =>
    ((window.history.state as { idx?: number } | null)?.idx ?? 0) > 0;

export function seen(iso?: string): string {
    if (!iso) return 'Never seen';
    const ms = Date.now() - new Date(iso).getTime();
    if (Number.isNaN(ms)) return 'Never seen';
    if (ms < 90 * 1000) return 'Seen just now';
    if (ms < 90 * 60 * 1000) return `Seen ${Math.round(ms / 60000)}m ago`;
    if (ms < 36 * 3600 * 1000) return `Seen ${Math.round(ms / 3600000)}h ago`;
    return `Seen ${Math.round(ms / 86400000)}d ago`;
}
